import { render, staticRenderFns } from "./GroupDialogEdit.vue?vue&type=template&id=6d4fd105&"
import script from "./GroupDialogEdit.vue?vue&type=script&lang=js&"
export * from "./GroupDialogEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports